/**
 * Helper to render media URLs that may be relative (uploaded) or absolute (CDN).
 */
import { BACKEND_URL } from "@/lib/api";

export function mediaUrl(u) {
  if (!u) return "";
  if (u.startsWith("http") || u.startsWith("//") || u.startsWith("data:")) return u;
  return `${BACKEND_URL}${u}`;
}

export function extractYouTubeId(url) {
  if (!url) return "";
  const patterns = [
    /youtube\.com\/watch\?v=([^&]+)/,
    /youtu\.be\/([^?]+)/,
    /youtube\.com\/embed\/([^?]+)/,
    /youtube\.com\/shorts\/([^?]+)/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return "";
}
